// extracted by mini-css-extract-plugin
export default {"activeIcon":"global_activeIcon__OGMbD","simpleIcon":"global_simpleIcon__OgIAs","emptyIcon":"global_emptyIcon__6AdoA"};